import React from "react";
import "./Muhammadabad.css"; // Reuse your CSS
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const ChiraiyaKot = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Popular Aluminium Works in Chiraiya Kot, Mau | Trusted Fabricators</title>
        <meta
          name="description"
          content="Find top aluminium works in Chiraiya Kot, Mau, Uttar Pradesh. Skilled fabricators provide sliding windows, aluminium doors, partitions, kitchen cupboards, ACP works, and custom aluminium solutions for homes and commercial properties."
        />
        <meta
          name="keywords"
          content="Aluminium Works Chiraiya Kot UP, Aluminium Fabricators, Sliding Windows, Aluminium Doors, Partitions, Kitchen Cupboards, ACP Works, Custom Aluminium Work, Window Installation"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Popular Aluminium Works in Chiraiya Kot, Mau" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, ACP works, and custom solutions for homes and commercial properties in Chiraiya Kot."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Popular Aluminium Works in Chiraiya Kot, Mau" />
        <meta
          name="twitter:description"
          content="Skilled aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, ACP works, and custom solutions in Chiraiya Kot, Mau."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Popular Aluminium Works in Chiraiya Kot, Mau, Uttar Pradesh</h1>
            <p>
              Chiraiya Kot in Mau is a growing hub for aluminium fabrication, serving residential, commercial, and industrial needs. From sliding windows and aluminium doors to partitions, kitchen cupboards, and ACP works, local fabricators provide durable, stylish, and low-maintenance solutions suitable for modern construction projects.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-works-chiraiyakot"
          />
        </div>
      </section>

      {/* WHY ALUMINIUM WORKS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Works Are Preferred in Chiraiya Kot</h2>
          <p>
            Aluminium works in Chiraiya Kot are highly favored due to their strength, longevity, and modern appearance. Local fabricators specialize in sliding windows, aluminium doors, partitions, kitchen cupboards, glass panels, and ACP works, ensuring precise fitting and long-lasting performance for both residential and commercial projects.
          </p>
          <p>
            Additional features like powder-coated frames, toughened glass, and customized designs allow aluminium solutions to perfectly complement different architectural styles.
          </p>
        </div>
      </section>

      {/* TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="trusted-fabricators-chiraiyakot"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators in Chiraiya Kot</h2>
          <p>
            Fabricators in Chiraiya Kot are recognized for their expertise, reliable installation, and personalized service. They manage everything from initial measurement to final installation, guiding customers on aluminium grades, glass thickness, and hardware to ensure quality results.
          </p>
          <p>
            Many local workshops also cater to nearby towns and villages, providing quick service, transparent pricing, and after-sales support for smooth project completion.
          </p>
        </div>
      </section>

      {/* SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are highly popular in Chiraiya Kot due to their modern look and space-saving design. They are ideal for bedrooms, kitchens, offices, and balconies. Sliding aluminium doors with glass panels enhance commercial properties with style, security, and functionality.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and ACP Works in Chiraiya Kot</h2>
          <p>
            Local fabricators provide custom aluminium partitions, window grills, office cabins, kitchen cupboards, glass panels, and ACP front elevations. Customized work ensures perfect fitting, elegant finishing, and long-lasting durability. Repair and replacement services for sliding systems, locks, and glass panels are also offered.
          </p>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas-chiraiyakot"
          />
          <div className="dp-box">
            <h2>Serving Chiraiya Kot and Nearby Areas</h2>
            <p>
              Aluminium works in Chiraiya Kot are available across nearby villages, towns, and marketplaces. Local service coverage allows homeowners, builders, and shopkeepers to schedule measurements, site visits, and installations efficiently, ensuring timely project completion.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="aluminium-content">
        <div className="container">
          <h1>Choosing Aluminium Works in Chiraiya Kot</h1>
          <p>
            Chiraiya Kot is a trusted location for aluminium fabrication, sliding windows, doors, partitions, kitchen cupboards, glass works, and ACP solutions. Local fabricators offer quality workmanship, modern designs, and durable results for homes, offices, and commercial buildings.
          </p>

          <h2>Top Aluminium Fabricators in Chiraiya Kot</h2>
          <p>
            Leading fabricators specialize in aluminium windows, doors, partitions, grills, and decorative works, ensuring long-lasting installations and timely service for various residential and commercial requirements.
          </p>

          <h2>Top Aluminium Door Dealers in Chiraiya Kot</h2>
          <p>
            Aluminium doors are widely preferred for durability, security, and aesthetic appeal. Trusted dealers provide a wide range of options suitable for homes, offices, and shops.
          </p>

          <h2>Sliding Window Solutions in Chiraiya Kot</h2>
          <p>
            Sliding windows are favored for their modern appearance, easy operation, and space-saving design. Custom options include mosquito mesh, safety grills, powder-coated finishes, and tailored dimensions.
          </p>

          <h2>Kitchen Cupboards & Custom Aluminium Works</h2>
          <p>
            Aluminium kitchen cupboards, office partitions, and cabins are designed for durability, modern aesthetics, and low maintenance. Custom work ensures proper fitting and superior finishing.
          </p>

          <h2>ACP & Front Elevation Works</h2>
          <p>
            Many fabricators specialize in ACP panels for front elevations and interiors. These installations provide contemporary looks, strength, and easy maintenance for commercial and residential projects.
          </p>

          <h2>Top Hardware Dealers in Chiraiya Kot</h2>
          <p>
            Hardware dealers supply essential fittings, locks, handles, and accessories for aluminium, glass, and ACP works, ensuring smooth operation and long-lasting performance.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today in Chiraiya Kot, Mau</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default ChiraiyaKot;
